import { GET_NEWEST_PROJECTS_API_ENDPOINT } from '@/constants';
import { IHousingObjectResponse } from '@/types';
import { getAcceptLanguageHeader, type Locale } from '@/config/i18n/locales';
import { fetchWithAuth } from '@/lib/fetchWithAuth';
import { withServerTiming } from '@/lib/serverTiming';
import { logSsrFetch } from '@/lib/ssrLog';

export const fetchNewestProjectsSsr = async (locale?: Locale): Promise<IHousingObjectResponse[]> =>
  withServerTiming('fetchNewestProjectsSsr', async () => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (locale) headers['Accept-Language'] = getAcceptLanguageHeader(locale);

      const url = `${process.env.NEXT_PUBLIC_API_URL}${GET_NEWEST_PROJECTS_API_ENDPOINT}`;
      const { res, auth, ms } = await fetchWithAuth(url, {
        method: 'GET',
        cache: 'no-store',
        headers,
      });
      logSsrFetch({ url, timing: ms, status: res.status, auth });

      if (!res.ok) return [];
      return (await res.json()) as IHousingObjectResponse[];
    } catch (err) {
      console.error('fetchNewestProjectsSsr ERROR:', err);
      return [];
    }
  });
